import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "fm722_token";

export const tokenStore = {
  get: () => { try { return localStorage.getItem(TOKEN_KEY); } catch { return null; } },
  set: (t) => { try { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ } },
  clear: () => { try { localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ } },
};

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Attach Authorization header as a fallback when cookies are blocked (iframes, strict-privacy browsers).
api.interceptors.request.use((config) => {
  const t = tokenStore.get();
  if (t) config.headers = { ...config.headers, Authorization: `Bearer ${t}` };
  return config;
});

// Global 401 handler: redirect to /login on session expiry from a protected page.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const onAuthPage = ["/login", "/register", "/forgot-password", "/reset-password"].some((p) =>
      window.location.pathname.startsWith(p),
    );
    const isAuthMeCheck = url.endsWith("/auth/me");
    const isPublicViewer = window.location.pathname.startsWith("/p/") || window.location.pathname.startsWith("/community");

    if (status === 401 && !isAuthMeCheck && !onAuthPage && !isPublicViewer) {
      tokenStore.clear();
      const next = window.location.pathname + window.location.search;
      window.location.assign(`/login?next=${encodeURIComponent(next)}&reason=session_expired`);
    }
    return Promise.reject(error);
  },
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/** Pull the most human-readable error string out of an axios error. */
export function extractApiError(err, fallback = "Something went wrong. Please try again.") {
  const detail = formatApiErrorDetail(err?.response?.data?.detail);
  if (detail) return detail;
  if (err?.message && err.message !== "Network Error") return err.message;
  if (err?.response?.status) return `Request failed (HTTP ${err.response.status}).`;
  return fallback;
}
